import React from 'react';
import styled from 'styled-components';
import anulogo from '../assets/images/logo-ANU-black.svg';
import trilogo from '../assets/images/TRI-logo.png';
import adclogo from '../assets/images/adc-logo.svg';
import aihwlogo from '../assets/images/aihw-logo.svg';
import tgalogo from '../assets/images/gta-logo.png';
import cathlogo from '../assets/images/cath-logo.png';
import cercis from "../assets/images/cercis.webp";
import lacasa from "../assets/images/lacasa.png";

const LogosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem;
  padding: 2rem;
  max-width: 1800px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 1.5rem;
    padding: 1.5rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 1rem;
    padding: 1rem;
  }
`;

const LogoLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  padding: 1rem;
  transition: all 0.3s ease;
  filter: grayscale(100%);
  
  &:hover {
    filter: grayscale(0%);
    transform: scale(1.05);
  }
`;

const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  filter: ${props => props.isAIHW ? 'contrast(0)' : 'none'};
`;

const CompanyLogos = () => {
  const companies = [
    { name: 'Australian National University', logo: anulogo, url: 'https://asiapacific.anu.edu.au/' },
    { name: 'CATH', logo: cathlogo, url: 'https://www.cath.live' },
    { name: 'AIHW', logo: aihwlogo, url: 'https://www.aihw.gov.au', isAIHW: true },
    { name: 'GTA', logo: tgalogo, url: 'https://www.tga.gov.au' },
    { name: 'ADC', logo: adclogo, url: 'https://www.adc.gov.au' },
    { name: 'TRI', logo: trilogo, url: 'https://www.tri.edu.au' },
    { name: 'Cercis', logo: cercis, url: 'https://www.cercis.com.au' },
    { name: 'Lacasa', logo: lacasa, url: 'https://www.lacasa.com.au' },
    // Add more companies as needed
  ];

  return (
    <LogosContainer>
      {companies.map((company, index) => (
        <LogoLink key={index} href={company.url} target="_blank" rel="noopener noreferrer">
          <LogoImage 
            src={company.logo} 
            isAIHW={company.isAIHW} 
          />
        </LogoLink>
      ))}
    </LogosContainer>
  );
};

export default CompanyLogos; 